import React from 'react';
import styles from './SocialButtonsList.scss';
import { IconButton } from '../IconButton/IconButton';
import classNames from 'classnames';
import { smsDonationIcon } from '@justgiving/icons';
import Svg from '@justgiving/svg';
import { useTranslation } from 'react-i18next';

interface SMSShareRoundProps {
  className?: string;
  message: string;
}

export const SMSShareRound: React.FunctionComponent<SMSShareRoundProps> = ({
  className,
  message,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });

  return (
    <IconButton className={`${styles.roundButton} ${className}`}>
      <a href={`sms://?&body=${encodeURIComponent(message)}`}>
        <div className={classNames(styles.iconWrapper, styles.sms)}>
          <Svg markup={smsDonationIcon} className={styles.icon} />
        </div>
        {t('shareModal.sms')}
      </a>
    </IconButton>
  );
};
